import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=957d8de2&scoped=true&lang=pug&"
import script from "./Register.js?vue&type=script&lang=js&"
export * from "./Register.js?vue&type=script&lang=js&"
import style0 from "./Register.sass?vue&type=style&index=0&id=957d8de2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957d8de2",
  null
  
)

export default component.exports